module.exports = __webpack_public_path__ + "static/media/hardy-floating-phones.6c081882.jpg";